import createSvgIcon from "./utils/create_icon"

const CheckmarkFill = createSvgIcon(<path clipRule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm3.707-11.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z" fill="currentColor" fillRule="evenodd" />, "CheckmarkFill")
export default CheckmarkFill
